import { render, staticRenderFns } from "./LangIcon.vue?vue&type=template&id=e3964eb8&"
import script from "./LangIcon.vue?vue&type=script&lang=js&"
export * from "./LangIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports